<template>
<div>
  <ThirdPartyLitigationTab6 />
<!--  <el-tabs v-model="card_index">-->
<!--    <el-tab-pane label="待审核" name="list">-->
<!--      <ThirdPartyLitigationTab1 v-if="card_index==='list'" />-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="审核中" name="shz">-->
<!--      <ThirdPartyLitigationTab5 v-if="card_index==='shz'" />-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="已审核" name="ys">-->
<!--      <ThirdPartyLitigationTab2 v-if="card_index==='ys'" />-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="驳回" name="bh">-->
<!--      <ThirdPartyLitigationTab3 v-if="card_index==='bh'" />-->
<!--    </el-tab-pane>-->
<!--  </el-tabs>-->
</div>
</template>

<script>
import ThirdPartyLitigationTab5 from "./ThirdPartyLitigationTab5";
import ThirdPartyLitigationTab2 from "./ThirdPartyLitigationTab2";
import ThirdPartyLitigationTab3 from "./ThirdPartyLitigationTab3";
import ThirdPartyLitigationTab1 from "./ThirdPartyLitigationTab1";
import ThirdPartyLitigationTab6 from "./ThirdPartyLitigationTab6";

export default {
  name: "ThirdPartyLitigationListLayout",
  components: {
    ThirdPartyLitigationTab6,
    ThirdPartyLitigationTab5, ThirdPartyLitigationTab2, ThirdPartyLitigationTab3, ThirdPartyLitigationTab1},
  data(){
    return{
      card_index:"list"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationListLayout.vue